import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { rsvpEmailTemplate, createMailtoLink } from '../utils/emailTemplates';

const Welcome: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Wedding date - update this to your actual wedding date
  const weddingDate = new Date('2026-08-21T15:00:00'); // Example: June 21, 2025 at 3:00 PM

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = weddingDate.getTime() - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-gradient-to-br from-cream via-white to-blush flex items-start justify-center p-4 pt-16" style={{ minHeight: '90vh' }}>
      <div className="max-w-4xl mx-auto text-center">
        
        {/* Names */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <div className="flex items-center justify-center gap-4 mb-8">
            <h1 className="main-heading">
              Cat <span className="text-gold">&</span> Rich
            </h1>
          </div>
          <div className="elegant-divider mb-12"></div>
        </motion.div>

        {/* Wedding Date */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          style={{ marginBottom: '2rem' }}
        >
          <p className="body-text mb-6">
            are getting married
          </p>
          <p className="script-heading mb-6">
            1st January, 1970
          </p>
          <p className="small-text">
            at 3:00 PM • Venue Name, Location
          </p>
        </motion.div>

        {/* Countdown */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          style={{ marginBottom: '2rem' }}
        >
          <div className="grid grid-cols-4 gap-4 max-w-md mx-auto">
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-4 shadow-lg">
              <div className="countdown-number">
                {timeLeft.days}
              </div>
              <div className="small-text">Days</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-4 shadow-lg">
              <div className="countdown-number">
                {timeLeft.hours}
              </div>
              <div className="small-text">Hours</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-4 shadow-lg">
              <div className="countdown-number">
                {timeLeft.minutes}
              </div>
              <div className="small-text">Minutes</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-4 shadow-lg">
              <div className="countdown-number">
                {timeLeft.seconds}
              </div>
              <div className="small-text">Seconds</div>
            </div>
          </div>
        </motion.div>

        {/* RSVP Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          style={{ marginTop: '3rem' }}
        >
          <a
            href={createMailtoLink('contact@catandri.ch', rsvpEmailTemplate.subject, rsvpEmailTemplate.body)}
            className="inline-block px-8 py-3 text-charcoal hover-text-gold transition-colors duration-300 button-text bg-transparent"
          >
            RSVP
          </a>
          <p className="small-text mt-4">
            Please respond by 1st May, 2025
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Welcome;